import moment from 'moment';

const SATURDAY = 6;
const SUNDAY = 0;

export type PlotBand = {
  color: string;
  from: number;
  to: number;
};

export function isWeekendDay(date: string): boolean {
  const day = moment.utc(date).day();

  return day === SATURDAY || day === SUNDAY;
}

export function buildWeekendPlotBands(startDate: string, endDate: string, color: string): PlotBand[] {
  const bands: PlotBand[] = [];
  const cursor = moment.utc(startDate).startOf('day');
  const end = moment.utc(endDate).startOf('day');
  let bandStart: number | null = null;

  while (cursor.isSameOrBefore(end)) {
    const isWeekend = cursor.day() === SATURDAY || cursor.day() === SUNDAY;

    if (isWeekend && bandStart === null) {
      bandStart = cursor.valueOf();
    } else if (!isWeekend && bandStart !== null) {
      bands.push({ color, from: bandStart, to: cursor.valueOf() });
      bandStart = null;
    }
    cursor.add(1, 'day');
  }

  if (bandStart !== null) {
    bands.push({ color, from: bandStart, to: cursor.valueOf() });
  }

  return bands;
}
